/* eslint-disable */
import React from 'react';
import { Container } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';

/**
 * Test page for iOS deep link. Use a button (not <a>) so the URL is not resolved as relative
 * by the SPA/router. Safari does NOT open the app when you paste the URL in the address bar.
 */
export default function OpenAppPage() {
  const [searchParams] = useSearchParams();
  const station = searchParams.get('station') || '34';
  const deepLink = `km220://charging?station=${station}`;

  const handleOpenApp = (e) => {
    e.preventDefault();
    e.stopPropagation();
    window.location.assign(deepLink);
  };

  const handleOpenAppNewWindow = (e) => {
    e.preventDefault();
    e.stopPropagation();
    window.open(deepLink, '_blank');
  };

  return (
    <Container style={{ minHeight: '60vh', paddingTop: '4rem', textAlign: 'center' }}>
      <p style={{ marginBottom: '1rem', fontSize: '1rem' }}>
        Tap the button below to open the 220 km app (iOS). Pasting the URL in Safari address bar does not work.
      </p>
      <p style={{ marginBottom: '0.5rem', fontSize: '0.85rem', color: '#666' }}>
        If the first button leads to a wrong URL, try &quot;Open in app (new window)&quot;.
      </p>
      <button
        type="button"
        onClick={handleOpenApp}
        style={{
          padding: '1rem 1.5rem',
          fontSize: '1.25rem',
          backgroundColor: '#292929',
          color: '#fff',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer',
        }}
      >
        Open in 220 km app (station {station})
      </button>
      <button
        type="button"
        onClick={handleOpenAppNewWindow}
        style={{
          marginTop: '1rem',
          marginLeft: '0.5rem',
          padding: '1rem 1.5rem',
          fontSize: '1rem',
          backgroundColor: '#555',
          color: '#fff',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer',
        }}
      >
        Open in app (new window)
      </button>
      <p style={{ marginTop: '1.5rem', fontSize: '0.9rem', color: '#666' }}>
        Deep link: <code>{deepLink}</code>
      </p>
    </Container>
  );
}
